<template>
    <div style="width: 100%; height: 100vh;" class="d-flex align-center justify-center" @keydown.enter="welcomeToSystem">
        <v-card min-width="500" rounded="lg" style="background-color: #5B951A;">
            <v-card-title class="my-2 d-flex justify-center align-center">
                <span class="ml-2" style="color: white;">Авторизация</span>
            </v-card-title>

            <v-card-text style="background-color: #FFFFFF; border-radius: 6px !important; margin: 0px 2px 2px !important; padding-bottom: 12px !important;">
                <v-form ref="form" v-model="formValid">
                    <v-text-field 
                        v-model="authObj.login"
                        :label="'Логин'"
                        variant="outlined"
                        color="#5B951A"
                        :rules="[rules.required]"
                        class="pt-6 pb-3"
                        clearable
                    />
                    <v-text-field 
                        v-model="authObj.password"
                        :label="'Пароль'"
                        variant="outlined"
                        color="#5B951A"
                        type="password"
                        :rules="[rules.required]"
                        class="mb-3"
                        clearable
                    />
                </v-form>
                <v-btn
                    block
                    color="#5B951A"
                    :loading="loading"
                    @click="welcomeToSystem"
                >
                    Войти
                </v-btn>
            </v-card-text>
        </v-card>
    </div>

    <v-snackbar v-model="api.snack.snackVisible" :text="api.snack.snackText" :color="api.snack.snackColor"></v-snackbar>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useApi } from '@/stores/apiTemplate';

const router = useRouter();
const api = useApi();

const authObj = reactive({
    login: '',
    password: ''
});
const form = ref(null);
const formValid = ref(false);
const loading = ref(false);
const rules = reactive({
    required: value => !!value || 'Поле обязательно для заполнения',
})

onMounted(() => {
    const token = api.getFromCookieAndDecodeToken();
    if (token) router.push({path: '/main'})
})

async function welcomeToSystem() {
    form.value.validate();
    if (formValid.value) {
        loading.value = true;
        await api.auth(authObj);
        loading.value = false;
        router.push({path: '/main'});
    }
}
</script>

<style scoped>

</style>